var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6006 7.91978L15.7996 6.97476L12.7583 1.08421C12.5995 0.775225 12.2706 0.580078 11.9096 0.580078C11.5485 0.580078 11.2215 0.775225 11.0609 1.08421L8.01954 6.97476L1.21858 7.91978C0.861335 7.96857 0.566464 8.20708 0.454942 8.53594C0.34342 8.86299 0.43604 9.22257 0.694997 9.46289L5.6152 14.0488L4.45272 20.523C4.39224 20.8627 4.53778 21.2042 4.82887 21.4066C4.99332 21.5205 5.18801 21.5801 5.38459 21.5801C5.53581 21.5801 5.68703 21.5457 5.82501 21.4771L11.9077 18.4198L17.9904 21.4771C18.3098 21.6379 18.6954 21.6108 18.9865 21.4084C19.2776 21.206 19.4231 20.8627 19.3626 20.5248L18.2002 14.0507L23.1204 9.46469C23.3774 9.22437 23.472 8.8648 23.3604 8.53775C23.2489 8.21069 22.954 7.97218 22.5968 7.92159L22.6006 7.91978Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.89b0d09b678567e801fc17466795025a.svg";
export { ForwardRef as ReactComponent };